import React, { useRef } from "react";
import { Carousel } from "@trendyol-js/react-carousel";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Box from "@mui/material/Box";
import FeaturedProduct from "./FeaturedProduct";
import { useTranslation } from "react-i18next";
import PinkBar from "../PinkBar";
import { useProductContext } from "../../context/ProductContext";
import ScrollMenu from "./ScrollMenu";

const FeaturedProducts = ({ numOfPic, currentLocation }) => {
  const { t, i18n } = useTranslation();
  const { products } = useProductContext();
  return (
    <Box sx={{ width: 9 / 10, py: 4, px: 4, ml: "auto", mr: "auto" }}>
      <Box sx={{ pb: 2, lineHeight: { xs: "2.5em" } }}>
        <PinkBar
          pt="3px"
          title={t(
            "Find your new eco-friendly and all natural cleaning product"
          )}
          subtitle={t(
            "Protect your family with Heslet's All Good Cleaning Solutions  "
          )}
        />
      </Box>
      {/* <Carousel
        leftArrow={<ArrowBackIosIcon sx={{ pt: 22, cursor: "pointer" }} />}
        rightArrow={<ArrowForwardIosIcon sx={{ pt: 22, cursor: "pointer" }} />}
        show={numOfPic}
        slide={1}
        transition={0.6}
        style={{
          display: "flex",
          flexDirection: "row",
          ustifyContent: "space-between",
          fontSize: "12px",
        }}
        swiping={true}
      >
        {products.map((pro, index) => {
          return (
            <FeaturedProduct
              key={index}
              img={pro.img}
              title={pro.title}
              linkTo={pro.linkTo}
              price={pro.price}
              // subtitle={pro.subtitle}
            />
          );
        })}
      </Carousel> */}

      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          overflowX: "scroll",
          py: 2,
        }}
      > */}
      {/* {products.map((pro, index) => {
          if (index === 0) {
            return (
              <Box sx={{ textAlign: "center", ml: "282px" }}>
                <Box
                  sx={{
                    border: "1px solid #eeeeee",
                    width: "200px",
                    mx: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 2,
                  }}
                >
                  <img
                    src={pro.img}
                    width="120"
                    height="140"
                    className="animation"
                    style={{ cursor: "pointer" }}
                  />
                </Box>
                <Box
                  sx={{
                    mt: 2,
                    position: "relative",
                    minHeight: "70px",
                    textAlign: "center",
                    width: 1,
                  }}
                >
                  <Box sx={{ mb: 2 }}>{pro.title}</Box>

                  <Box sx={{ position: "absolute", bottom: 0, left: 55 }}>
                    <span class="outer">
                      <span class="inner">${pro.price + 1}</span>
                    </span>
                    &nbsp;
                    <span style={{ color: "#508bed", fontSize: "18px" }}>
                      ${pro.price}
                    </span>
                  </Box>
                </Box>
              </Box>
            );
          } else {
            return (
              <Box sx={{ textAlign: "center", ml: "12px" }}>
                <Box
                  sx={{
                    border: "1px solid #eeeeee",
                    width: "200px",
                    mx: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 2,
                  }}
                >
                  <img
                    src={pro.img}
                    width="120"
                    height="140"
                    className="animation"
                    style={{ cursor: "pointer" }}
                  />
                </Box>
                <Box
                  sx={{
                    mt: 2,
                    position: "relative",
                    minHeight: "70px",
                    textAlign: "center",
                    width: 1,
                  }}
                >
                  <Box sx={{ mb: 2 }}>{pro.title}</Box>

                  <Box sx={{ position: "absolute", bottom: 0, left: 55 }}>
                    <span class="outer">
                      <span class="inner">${pro.price + 1}</span>
                    </span>
                    &nbsp;
                    <span style={{ color: "#508bed", fontSize: "18px" }}>
                      ${pro.price}
                    </span>
                  </Box>
                </Box>
              </Box>
            );
          }
        })}{" "} */}
      {/* <Box>Prev</Box> */}
      {/* </Box> */}
      <ScrollMenu products={products} currentLocation={currentLocation} />
    </Box>
  );
};

export default FeaturedProducts;
